<!--
� 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
-->

<div class="sidebar-container">
	<div class="sidebar">
		@for (sidebarItem of sidebarItems$ | async; track $index) {
			<div class="sidebar-item-container">
				@if (sidebarItem.isActive) {
					<div class="sidebar-item-active line"></div>
				}

				<a
					[routerLink]="sidebarItem.routerLink"
					class="sidebar-item"
					[ngClass]="{
						'sidebar-item-active': sidebarItem.isActive
					}"
				>
					<span [ngClass]="sidebarItem.icon"></span>

					@if (!isSidebarCollapsed) {
						<span class="sidebar-item-label">
							{{ sidebarItem.label }}
						</span>
					}
				</a>
			</div>
		}
	</div>

	<div class="sidebar-toggle-container">
		<globalictcc-button
			[iconOnly]="true"
			class="sidebar-toggle"
			(handleClick)="toggleSidebar()"
			[iconName]="isSidebarCollapsed ? 'expand-left' : 'expand-right'"
		/>
	</div>
</div>
